module.exports = __webpack_public_path__ + "static/img/member1.fa3c9c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/member1.jpg
// module id = pfz3
// module chunks = 1